import React from 'react';

import Layout from 'layouts/Layout';
import Cart from './Cart';

const CartLayout = ({ match }) => <Layout component={Cart} match={match} />;

export default CartLayout;
